import ApiCrud from "./api-crud";

class DirectoHoraService extends ApiCrud {
  resource = "directo_horas";
  primaryKey = "iddirecto_hora";
}

export default new DirectoHoraService();
